import OriginalHeader, { HeaderColumns, HeaderTitle } from './Header';
var Header = OriginalHeader;
Header.HeaderColumns = HeaderColumns;
Header.HeaderTitle = HeaderTitle;
export default Header;